import { _ as __assign, a as __awaiter, b as __generator } from '../../chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { F as FileViewerView } from '../../chunks/bundle-CcOOoseq.js';
import { useGroupChannelContext } from '../context.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import 'react-dom';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import '../../chunks/bundle-DP3z2QNm.js';
import '../../chunks/bundle-DRpjMk0B.js';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../chunks/bundle-Ci-RNuvu.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '@sendbird/uikit-tools';
import '../../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-DXFVroy5.js';
import '../../chunks/bundle-BoENnpQQ.js';
import '../../chunks/bundle-B_14cMxa.js';
import '../../chunks/bundle-rjBen5BS.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../chunks/bundle-3sZs8f9n.js';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-QgerWYLz.js';
import '../../chunks/bundle-BW3AiewC.js';

var FileViewer = function (props) {
    var _a = useGroupChannelContext(), deleteMessage = _a.deleteMessage, onBeforeDownloadFileMessage = _a.onBeforeDownloadFileMessage;
    var config = useSendbirdStateContext().config;
    var logger = config.logger;
    return (React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage, onDownloadClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!onBeforeDownloadFileMessage)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: props.message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (!allowDownload) {
                            e.preventDefault();
                            (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileViewer: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileViewer: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } })));
};

export { FileViewer, FileViewer as default };
//# sourceMappingURL=FileViewer.js.map
